import React from "react";

/* Eye / eye-off — password visibility toggles. */
export const EyeIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M1.5 10S4.6 4.5 10 4.5 18.5 10 18.5 10 15.4 15.5 10 15.5 1.5 10 1.5 10z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="10" cy="10" r="2.6" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const EyeOffIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M8.2 4.7A7.6 7.6 0 0110 4.5c5.4 0 8.5 5.5 8.5 5.5a15 15 0 01-2.35 2.98M5.1 5.9A14.9 14.9 0 001.5 10S4.6 15.5 10 15.5c1.2 0 2.28-.27 3.23-.7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.3 8.4a2.6 2.6 0 003.4 3.4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.8 2.8l14.4 14.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default EyeIcon;
